import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { FaSignInAlt } from 'react-icons/fa';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(email, password);
      toast.success('Login successful!');
      navigate('/contacts');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page" id="login-page">
      <div className="auth-card" id="login-card">
        <h1 id="login-title">Contact List App</h1>
        <form onSubmit={handleSubmit} id="login-form">
          <div className="form-group">
            <label htmlFor="email-input">Email</label>
            <input
              id="email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your email"
              autoComplete="email"
            />
          </div>
          <div className="form-group">
            <label htmlFor="password-input">Password</label>
            <input
              id="password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
              autoComplete="current-password"
            />
          </div>
          <button
            id="login-submit-btn"
            type="submit"
            className="btn btn-primary btn-full"
            disabled={loading}
          >
            <FaSignInAlt />
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: '20px', color: 'var(--text-secondary)' }}>
          Don't have an account?{' '}
          <Link to="/register" id="register-link" style={{ color: 'var(--primary-color)' }}>
            Register here
          </Link>
        </p>
        <a
          href="/api/docs"
          target="_blank"
          rel="noopener noreferrer"
          className="swagger-link"
          id="swagger-link"
        >
          View API Documentation (Swagger)
        </a>
        <div style={{ 
          textAlign: 'center', 
          marginTop: '30px', 
          paddingTop: '20px',
          borderTop: '1px solid var(--border-color)',
          fontSize: '14px',
          color: 'var(--text-secondary)'
        }}>
          Designed by{' '}
          <a 
            href="https://siarheistamal.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              color: 'var(--primary-color)', 
              textDecoration: 'none',
              fontWeight: '500'
            }}
          >
            Siarhei
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login;
